import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import { handleChange, handleSubmit } from "../../controller/DocumentController/CreateDocumentController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import { useDropzone } from 'react-dropzone';
function CreateDocument({ currentDocument, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        ID: 0, FileName: '', Path: '', Name: '',
        Description: '', File: null, ModuleID: 0
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [UserList, setUserList] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [formList, setFormList] = useState([]);

    const fetchForms = async (ClientID) => {
        try {
            const list = await ModuleService.GetAllModules();
            setFormList(list || []);
        } catch (error) {
            console.error('Error fetching Modules:', error);
        }
    };

    useEffect(() => {
        fetchForms();
        if (currentDocument) {
            setFormData({
                ID: currentDocument.ID, FileName: currentDocument.FileName, Path: currentDocument.Path, DocumentName: currentDocument.DocumentName,
                Description: currentDocument.Description, File: null, ModuleID: currentDocument.ModuleID
            });
        } else {
            setFormData({
                ID: 0, FileName: '', Path: '', Name: '',
                Description: '', File: null, ModuleID: 0
            });
        }
    }, [currentDocument]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = async (event) => {
        debugger;
        event.preventDefault();

        if (currentDocument) {
            formData.DocID = currentDocument.DocID;
        } else {
            formData.DocID = 0;
        }

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        const response = await handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess();

        }, () => {
            onSuccess();

        });
    };
    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
            setFormData(prevState => ({
                ...prevState,
                File: file,
                Path: file.name
            }));
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade DocumentModal show d-block" id="DocumentModal" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="DocumentModalLabel" aria-hidden="true">


                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentDocument ? "Edit Document" : "Add Document"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <table style={{ width: "100%", marginTop: "10px" }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ marginLeft: "13%" }}><label htmlFor="DocumentName" style={{ float: "right" }}>Name <span style={{ "color": "red" }}>*</span></label></td>
                                                <td style={{ marginLeft: "37%" }}>
                                                    <input type="text" className="form-control" name="DocumentName" value={formData.DocumentName} onChange={handleFieldChange} />
                                                    {errors.DocumentName && <div style={{ color: 'red' }}>{errors.DocumentName}</div>}
                                                </td>
                                                <td style={{ marginLeft: "13%" }}>
                                                    <label htmlFor="Description" style={{ float: "right" }}>Description &nbsp;&nbsp;</label>
                                                </td>
                                                <td style={{ marginLeft: "37%" }}>
                                                    <input type="text" className="form-control" name="Description" value={formData.Description} onChange={handleFieldChange} />
                                                    {errors.Description && <div style={{ color: 'red' }}>{errors.Description}</div>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ marginLeft: "13%" }}><label htmlFor="Name" style={{ float: "right" }}>Select Module <span style={{ "color": "red" }}>*</span></label></td>
                                                <td style={{ marginLeft: "37%" }}>
                                                    <select
                                                        name="ModuleID"
                                                        className="form-control"
                                                        onChange={handleFieldChange}
                                                        value={formData.ModuleID}
                                                    >
                                                        <option value="0">Select Module</option>
                                                        {formList.map((form) => (
                                                            <option
                                                                key={form.PK_SearchModule_ID}
                                                                value={form.PK_SearchModule_ID}
                                                            >
                                                                {form.vc_ModuleName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>

                                                </td>
                                                <td>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>  <label htmlFor="Path" style={{ float: "right" }}>Attach File <span style={{ "color": "red" }}>*</span></label>
                                                </td>
                                                <td colSpan={3}>
                                                    <div
                                                        {...getRootProps()}
                                                        style={{
                                                            border: '2px dashed #ccc',
                                                            padding: '20px',
                                                            borderRadius: '6px',
                                                            textAlign: 'center',
                                                            backgroundColor: isDragActive ? '#e6f7ff' : '#ffffff',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        <input {...getInputProps()} />
                                                        {
                                                            formData.Path
                                                                ? <p>{formData.Path}</p>
                                                                : <p>Drag & drop a file here, or click to select</p>
                                                        }
                                                    </div>
                                                    {errors.Path && <div style={{ color: 'red' }}>{errors.Path}</div>}

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                                        {currentDocument ? " Update" : " Save"}

                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>

            </form >
        </div>
    );
}

export default CreateDocument;
